import { t } from "../../../features/store-language/i18n.ts";
import { HttpService } from "../../../utils/DesigningHttpService.js";
import { readStore, storeMediaReference } from "../storefrontService.ts";
import { agencySessionKey } from "../../../utils/agencySession.ts";

const http = new HttpService();
const orderVersions = new Map<number, { session: string | null; version: string }>();

export function mapStoreOrder(order: any): any {
  return { ...order, orderNo: order.orderNumber, date: order.orderedAt, createAt: order.orderedAt,
    status: order.status === "Confirmed" ? "قطعی" : "پیش نویس",
    previewFileIds: (order.previewMediaIds || []).map(function (id) { return `store-order:${order.id}:${id}`; }),
    items: order.items.map(function (line) {
      return { ...line, patternId: line.productVariantId, name: line.title, count: line.quantity,
        unitPrice: line.sourceUnitPrice, dimension: line.area == null ? "" : String(line.area),
        palette: line.paletteTitle || "", fileId: line.thumbnailMediaId ? `store-order:${order.id}:${line.thumbnailMediaId}` : null };
    }) };
}

export async function readOrders(): Promise<any[]> {
  const orders: any[] = [];
  let page = 1;
  while (true) {
    const result = await readStore(`orders?page=${page}&pageSize=100`);
    orders.push(...result.items.map(mapStoreOrder));
    if (orders.length >= result.total || result.items.length === 0) { return orders; }
    page++;
  }
}

export async function readOrder(id: number, preserveVersion = false): Promise<any> {
  const session = agencySessionKey();
  const order = await readStore(`orders/${id}`);
  if (!preserveVersion) orderVersions.set(id, { session, version: order.version });
  return mapStoreOrder(order);
}

function orderVersion(id: number): string {
  const saved = orderVersions.get(id);
  if (!saved || saved.session !== agencySessionKey()) { throw new Error(t("ابتدا سفارش را باز کنید.")); }
  return saved.version;
}

export async function saveOrder(id: number, body: any): Promise<void> {
  await http.putForData(`/catalog/orders/${id}`, { version: orderVersion(id), description: body.description,
    items: body.items.map(function (line) {
      return { id: line.id > 0 ? line.id : null, productVariantId: line.patternId, quantity: line.quantity };
    }) });
}

export async function hideOrder(id: number): Promise<void> {
  await http.postasync(`/catalog/orders/${id}/delete`, { version: orderVersion(id) });
  orderVersions.delete(id);
}

export async function searchVariants(search: string): Promise<any[]> {
  const variants = await readStore(`variants?search=${encodeURIComponent(search)}`);
  return variants.map(function (variant) {
    return { id: variant.id, name: variant.title, code: variant.code, palette: variant.paletteTitle,
      dimension: variant.area == null ? "" : String(variant.area), fileId: storeMediaReference(variant.thumbnailMediaId) };
  });
}
